var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgNotificationsDm = function SvgNotificationsDm(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6M8.968 2C6.34 2.018 4 4.251 4 7v3.4c0 .9-.5 1.5-1.09 1.85-.4.24-.91.57-.91.97 0 .46.29.77.89.77h12.22c.6 0 .89-.32.89-.77 0-.4-.5-.73-.91-.97-.6-.35-1.09-.94-1.09-1.85V8.388A4.5 4.5 0 0 1 8.968 2M7.59 15c-.06.16-.09.32-.09.5 0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5c0-.18-.04-.34-.09-.5z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNotificationsDm);
export { ForwardRef as Icon };
export default "img/element-icons/roomlist/notifications-dm.fe70c8c.svg";